import * as _ from 'lodash';
import { AfterViewInit, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, first } from 'rxjs/operators';
import { selectOrgUser } from 'app/dashboard/features/dashboard.selectors';
import { CookieService } from 'ngx-cookie-service';
import { ModalLoginService } from '../../services/modal-login/modal-login.service';
import { AuthService } from '../../services/auth/auth.service';
import { loadOrgUser } from 'app/dashboard/features/dashboard.actions';
import { NavMenuService } from 'app/router-wrapper/services/nav-menu/nav-menu.service';
import { ModalSwitchOrganizationService } from 'app/router-wrapper/services/modal-switch-organization/modal-switch-organization.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-router-wrapper-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class RouterWrapperAppComponent implements OnInit, AfterViewInit {
  destroyRef = inject(DestroyRef)
  public orgUser = null;
  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    filter(user => !_.isNull(user)),
    filter((user: any) => {
      const { orgUser } = this;
      if(orgUser === null) {
        return true;
      }
      const { id: previousUserId, orgId: previousOrgId } = orgUser.loggedInUser || orgUser;
      const { id: currentUserId, orgId: currentOrgId } = user.loggedInUser || user;
      return previousUserId === currentUserId && previousOrgId === currentOrgId ? false: true;
    })
  );
  public access = [];
  public accessText = "";
  
  public userOrgs = [];

  public navMenu = [];
  public orgNavMenu = [];

  @Input() auction_show: boolean = false;

  constructor(
    public router: Router,
    private store: Store,
    private cookieService: CookieService,
    private modalLoginService: ModalLoginService,
    private modalSwitchOrganizationService: ModalSwitchOrganizationService,
    private authService: AuthService,
    private navMenuService: NavMenuService
  ) {
    window['routerWrapperAppComponent'] = this;
    this.navMenu = this.navMenuService.navMenu;
    this.orgNavMenu = this.navMenuService.orgNavMenu;
    
  }

  ngOnInit(): void {
    const $ = window['$'];

    this.orgUser$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((user: any) => {
      this.orgUser = user;
      const { access, userOrgs } = user.loggedInUser || {
        access: [1],
        userOrgs: []
      };
      this.access = access;
      this.userOrgs = userOrgs;

      const list = [];
      for(let permision of access) {
        switch(permision) {
          case 1:
            list.push("Account admin");
            break;
          case 2:
            list.push("Campaign Manager");
            break;
          case 3:
            list.push("Event Manager");
            break;
          case 4:
            list.push("Finance");
            break;
        }
      }
      this.accessText = `${list.join(", ")}`;

      for(let navMenuElement of this.navMenu) {
        const { length } = _.intersection(navMenuElement.access, access);
        navMenuElement.link.ngClass["disabled"] = length < 1;
        navMenuElement.link.ngClass["grey-text"] = length < 1;
        for(let navMenuSubElement of navMenuElement.children) {
          const { length } = _.intersection(navMenuSubElement.access, access);
          navMenuSubElement.link.ngClass["disabled"] = length < 1;
          navMenuSubElement.link.ngClass["grey-text"] = length < 1;
        }
      }

      const integrationMenu = this.navMenu.find((navMenuElement) => {
        return navMenuElement.id === 'integrationsPage';
      })
      integrationMenu.hide = user.enableWebHook ? false: true;

      window['orgMain'].showPaymentDue();
      if(user.payBeeStreamingEnabled) {
        window['$']('#sideMenuStreaming').show()
      } else {
        window['$']('#sideMenuStreaming').hide()
      }

      this.orgNavMenu[0].hide = userOrgs.length < 2;
      this.orgNavMenu[0].link.onClick = () => {
        this.modalSwitchOrganizationService.open(this.orgUser.loggedInUser);
      }
    });

    const auction_show = document.getElementById('app-router-wrapper-root').getAttribute('auction_show')
    
    if(auction_show !== 'true') {
      this.store.dispatch({
        type:loadOrgUser.type,
        payload:{reload:true}
      })
    }
  }

  ngAfterViewInit(): void {
    window['$']('#mooveCart').html('<paybee-update-cart--modal-element>Report</paybee-update-cart--modal-element>');
  }

  navigateByUrl(url: string) {
    return this.router.navigateByUrl(url);
  }

  expired() {
    this.authService.reset()

    const moddalRef = this.modalLoginService.open();
    moddalRef.onClose.pipe(
      first()
    ).subscribe(() => {
      this.navigateByUrl(this.router.url);
    })
  }
}
